import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import PendingUsersList from '../components/admin/PendingUsersList';

/**
 * Admin dashboard page component
 * Provides access to user management and other admin functions
 */
const Admin: React.FC = () => {
  const { isLoading, user } = useAuth();
  const [activeTab, setActiveTab] = useState<string>('users');

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <div className="admin-user-info">
          <span>Logged in as: {user?.firstName} {user?.lastName}</span>
          <span className="admin-role-badge">Admin</span>
        </div>
      </div>

      <div className="admin-tabs">
        <button 
          className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          User Management
        </button>
        <button 
          className={`admin-tab ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          Settings
        </button>
      </div>

      <div className="admin-content">
        {activeTab === 'users' && (
          <div className="admin-panel">
            <h2>User Management</h2>
            <div className="user-management-tabs">
              <button className="user-tab active">Pending Approval</button>
              <button className="user-tab">All Users</button>
            </div>
            <PendingUsersList />
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="admin-panel">
            <h2>Admin Settings</h2>
            <p>Configure admin settings here.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Admin;